import { Link, type SxProps, type Theme } from "@mui/material";
import type { ReactNode } from "react";
import { useIntercomContext } from "../../../contexts/IntercomContext.ts";

const linkSx: SxProps<Theme> = { textDecoration: "underline", cursor: "pointer", color: "inherit" };

interface Props {
  articleId: string;
  children: ReactNode;
}

const ReadMoreArticleLink = ({ articleId, children }: Props) => {
  const { showArticle } = useIntercomContext();
  return (
    <Link component="span" sx={linkSx} onClick={() => showArticle(articleId)}>
      {children}
    </Link>
  );
};

export default ReadMoreArticleLink;
